import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { getGroupByClient } from '../../actions/GroupAction'
import List from '../groups/List'
import Create from '../groups/Create'
import {Button, Icon, Modal, Tooltip} from 'antd'
import _ from "lodash";
import BunkeyGroupsTour from '../tour/BunkeyGroupsTour'
import {getPlanServicesByUser} from "../../actions/PlanServicesAction";
import { isEnterpriseUser } from '../../utils/plan-utils'

export class ListPermission extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showCreateGroup: false,
      groupsTourStep: 0
    }
  }

  componentDidMount() {
    const { workclient } = this.props
    this.props.getGroupByClient(workclient)
    this.props.getPlanServicesByUser(workclient);
  }

  handleShowCreateGroup = () => {
    this.setState({ showCreateGroup: true })
  }

  handleHideCreateGroup = () => {
    this.setState({ showCreateGroup: false })
  }

  render() {
    const { newColor, groupsByClient = [], intl, userServices, clienteSelected} = this.props
    // new
    const groupsTop = groupsByClient.length;
    const contractedGroups = 3
    // new
    const { showCreateGroup, groupsTourStep } = this.state

    const results = (userServices || []).find(({ idService }) => idService === "6424ad7089441071d65b7b27");
    const hireds = _.isNil(results);
    const isEnterprise = isEnterpriseUser(clienteSelected);

    return (
      <React.Fragment>
        <BunkeyGroupsTour
          onChangePage={(newPage) => {
            if(newPage !== groupsTourStep){
              this.setState({
                groupsTourStep: newPage
              });
              if(newPage === 1){
                this.handleShowCreateGroup();
              }
            }
            if(newPage !== 1 && groupsTourStep === 1){
              this.handleHideCreateGroup();
            }
          }}
          onRequestClose={()=>{
            if(groupsTourStep === 1){
              this.handleHideCreateGroup();
            }
          }}
        />
        <div className="title-bar">
          <div className="container" style={{ borderLeftColor: newColor }} >
            <span
              style={contractedGroups && (!isEnterprise && hireds) && (groupsTop >= contractedGroups) ? {color: 'red'} : {}}
              className='groups-page-title'
            > 
              {intl.formatMessage({ id: "groups" }) + ' ' + groupsTop + `${(!isEnterprise && hireds) ?  '/' + contractedGroups : ''}`} 
            </span>
            {
              contractedGroups && (!isEnterprise && hireds) && groupsTop >= contractedGroups &&
              <Tooltip title={intl.formatMessage({ id: 'info_group_max_limit' })} placement="right">
                <Icon style={{fontSize : '16px', margin: '10px', color: '#F0BB62'}} type="info-circle" />
              </Tooltip>
            }
            <div 
              className='groups-tour-button'
              style={{
                display: 'block',
                float: 'right',
                marginRight: 10,
                marginTop: 10
              }}
            >
              {!hireds || groupsTop < contractedGroups || isEnterprise ?

                <Button
                  type="primary"
                  onClick={this.handleShowCreateGroup}
                  style={{backgroundColor: newColor, borderColor: newColor, color: "white"}}
                >
                  <p style={{paddingBottom: "0px", marginBottom: "0px"}}>{intl.formatMessage({id: "create_group"})}</p>
                </Button>
                : <Tooltip title={intl.formatMessage({id: 'disabled_input_group'})} placement="left"><Button type="primary" disabled><p style={{paddingBottom: "0px", marginBottom: "0px"}}>{intl.formatMessage({id: "create_group"})}</p></Button></Tooltip>
              }
            </div>
          </div>
        </div>
        <div className="assets-wrapper">
          <div className="container">
            <List
              from={`ListPermission`}
              data={groupsByClient}
              isRemovable={true} />
          </div>
        </div>
        <Modal
          className="groups-create-drawer"
          title={intl.formatMessage({ id: "group_creation" })}
          width={'70%'}
          closable={true}
          footer={null}
          destroyOnClose={true}
          onCancel={this.handleHideCreateGroup}
          onClose={this.handleHideCreateGroup}
          visible={showCreateGroup}>
          {showCreateGroup && <Create handleClose={this.handleHideCreateGroup} />}
        </Modal>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    authUser: state.authUser.user,
    item: state.permission.item,
    workclient: state.client.workclient,
    newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
    isFetching: state.group.byClientIsFetching,
    groupsByClient: state.group.byClientData,
    userServices: state.planServices.userServices,
    clienteSelected: state.client.data,
  }
}

const mapDispatchToProps = {
  getGroupByClient,
  getPlanServicesByUser
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(ListPermission)))
